import * as types from '../ActionTypes/MetaActionTypes';

export class MetaActionCreators {
    static setToken(newToken) {
        return {
            type: types.SET_REFRESH_HASH,
            payload: newToken,
        };
    }

    static clearToken() {
        return {
            type: types.CLEAR_HASH,
        };
    }

    static setPassword(password, token) {
        return {
            type: types.SET_PASSWORD_REQUEST,
            payload: password,
            meta: { token },
        };
    }

    static setPasswordSuccess() {
        return {
            type: types.SET_PASSWORD_SUCCESS,
        };
    }
}



// WEBPACK FOOTER //
// ./src/Store/ActionCreators/MetaActionCreators.js